import { render, staticRenderFns } from "./RegistrationSearchForm.vue?vue&type=template&id=96434bc4&"
import script from "./RegistrationSearchForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports